<ms-widget-header [title]="title" [titleIcon]="'sports-favourites'" [fallbackIcon]="'sports-favourites'" />
@let headerNavigation = navigation();
@if (headerNavigation.length > 1) {
    @if (showPrimaryNavAsPill) {
        <ms-widget-pill [pills]="headerNavigation" (select)="navigationSelected($event)" />
    } @else {
        <ms-widget-tab-bar [tabs]="headerNavigation" (select)="navigationSelected($event)" />
    }
}

@if (grid$ | async; as gridModel) {
    <ms-grid [model]="gridModel" [tracking]="tracking" [hideTitle]="hideGridTitle" [iconTemplate]="undefined" (eventClick)="eventClicked($event)" />
} @else {
    <ms-error severity="info" [message]="contentErrorMessage" [links]="false" />
}

@if (isFooterVisible) {
    <div class="grid-footer">
        <ms-item [href]="footerLink" [tracking]="undefined" (click)="footerLinkClick()"
            ><span item-title [innerHtml]="footerLinkTitle | msTrust: 'html'"></span>
        </ms-item>
    </div>
}
